"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistCreator = void 0;

var _ = require("../../");

var _react = _interopRequireWildcard(require("react"));

require("./PlaylistCreator.css");

var _LottieLoading = require("../../molecules/LottieLoading");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Playlist Creator
var PlaylistCreator = function PlaylistCreator(_ref) {
  var forceLoading = _ref.forceLoading,
      onDidRequestCreateNewPlaylist = _ref.onDidRequestCreateNewPlaylist;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      _useState4 = _slicedToArray(_useState3, 2),
      isPrivate = _useState4[0],
      setIsPrivate = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      playlistName = _useState6[0],
      setPlaylistName = _useState6[1];

  var _useState7 = (0, _react.useState)(1),
      _useState8 = _slicedToArray(_useState7, 2),
      collectionColor = _useState8[0],
      setCollectionColor = _useState8[1]; // Handlers


  var handleDidRequestCreateNewPlaylist = function handleDidRequestCreateNewPlaylist() {
    if (typeof onDidRequestCreateNewPlaylist === "function") {
      onDidRequestCreateNewPlaylist({
        name: playlistName,
        private: isPrivate,
        color: collectionColor
      });
    }
  }; // State setters


  var setName = function setName(name) {
    if (name) {
      setError("");
      setPlaylistName(name);
      (0, _.trk)("CreateNewPlaylistTraceId:Name updated");
      return true;
    } else {
      setPlaylistName(name);
      setError("Name your playlist");
      return true;
    }
  };

  var setPlaylistColor = function setPlaylistColor(color) {
    setCollectionColor(color);
    (0, _.trk)("CreateNewPlaylistTraceId:Color changed");
  };

  var setPrivacy = function setPrivacy(value) {
    setIsPrivate(value);
    (0, _.trk)("CreateNewPlaylistTraceId:Privacy Changed");
  };

  return /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "PlaylistCreator"
  }, forceLoading && /*#__PURE__*/_react.default.createElement(_LottieLoading.LottieLoading, null), !forceLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.AddOrEditCollection, {
    error: error,
    setName: setName,
    name: playlistName,
    isPrivate: isPrivate,
    setPrivacy: setPrivacy,
    setPlaylistColor: setPlaylistColor
  })), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Button, {
    primary: true,
    trkPage: "true",
    content: "Create and save highlight",
    onClick: function onClick() {
      return handleDidRequestCreateNewPlaylist();
    }
  }))));
};

exports.PlaylistCreator = PlaylistCreator;